import React from "react";
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
} from "@mui/material";

export const ROOM_QUANTITY_DEFINITIONS = [
    { id: 1, legacy_id: 1, name: "rooms", label_de: "Anzahl Zimmer", sort_order: 10 },
    { id: 2, legacy_id: 2, name: "beds", label_de: "Anzahl Betten", sort_order: 20 },
    { id: 3, legacy_id: 8, name: "single_bed_rooms", label_de: "Anzahl Einzelbett Zimmer", sort_order: 30 },
    { id: 4, legacy_id: 9, name: "twin_rooms", label_de: "Anzahl Zweibett Zimmer", sort_order: 40 },
    { id: 5, legacy_id: 10, name: "double_rooms", label_de: "Anzahl Doppelzimmer", sort_order: 50 },
    { id: 6, legacy_id: 11, name: "triple_rooms", label_de: "Anzahl Dreibett Zimmer", sort_order: 60 },
    { id: 7, legacy_id: 12, name: "family_rooms", label_de: "Anzahl Familien Zimmer", sort_order: 70 },
    { id: 8, legacy_id: 3, name: "suites", label_de: "Anzahl Suiten", sort_order: 80 },
    { id: 9, legacy_id: 4, name: "apartments", label_de: "Anzahl Appartements", sort_order: 90 },
    { id: 10, legacy_id: 5, name: "holiday_apartments", label_de: "Anzahl Ferienwohnungen", sort_order: 100 },
    { id: 11, legacy_id: 6, name: "tourist_dormitories", label_de: "Anzahl Touristenlager", sort_order: 110 },
    { id: 12, legacy_id: 7, name: "sleeping_in_straw", label_de: "Anzahl Schlafen im Stroh", sort_order: 120 },
    { id: 13, legacy_id: 13, name: "camping_pitches", label_de: "Anzahl Zeltplätze / Camping", sort_order: 130 },
];

export const ROOM_DETAIL_DEFINITIONS = [
    { id: 1, legacy_id: 3, name: "bath_or_shower", label_de: "Bad oder Dusche", sort_order: 10 },
    { id: 2, legacy_id: 11, name: "balcony_or_terrace", label_de: "Balkon oder Terrasse", sort_order: 20 },
    { id: 3, legacy_id: 1, name: "shower", label_de: "Dusche", sort_order: 30 },
    { id: 4, legacy_id: 10, name: "air_conditioning", label_de: "Klimaanlage", sort_order: 40 },
    { id: 5, legacy_id: 4, name: "minibar", label_de: "Minibar", sort_order: 50 },
    { id: 6, legacy_id: 9, name: "non_smoking_rooms", label_de: "Nichtraucherzimmer", sort_order: 60 },
    { id: 7, legacy_id: 7, name: "safe", label_de: "Safe", sort_order: 70 },
    { id: 8, legacy_id: 6, name: "phone", label_de: "Telefon", sort_order: 80 },
    { id: 9, legacy_id: 5, name: "tv", label_de: "TV", sort_order: 90 },
    { id: 10, legacy_id: 12, name: "sink", label_de: "Waschbecken", sort_order: 100 },
    { id: 11, legacy_id: 2, name: "toilet", label_de: "WC", sort_order: 110 },
    { id: 12, legacy_id: 8, name: "wifi", label_de: "WLAN", sort_order: 120 },
];

export const ROOM_PRICE_DEFINITIONS = [
    { id: 1, legacy_id: 1, name: "single_bed_room", label_de: "Einzelbett Zimmer", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 10 },
    { id: 2, legacy_id: 2, name: "twin_room", label_de: "Zweibett Zimmer", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 20 },
    { id: 3, legacy_id: 14, name: "double_room", label_de: "Doppelzimmer", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 30 },
    { id: 4, legacy_id: 3, name: "triple_room", label_de: "Dreibett Zimmer", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 40 },
    { id: 5, legacy_id: 4, name: "family_room", label_de: "Familien Zimmer", supports_reference: 1, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 50 },
    { id: 6, legacy_id: 5, name: "suite_junior_suite", label_de: "Suite / Juniorsuite", supports_reference: 1, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 60 },
    { id: 7, legacy_id: 15, name: "apartment", label_de: "Appartement", supports_reference: 1, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 70 },
    { id: 8, legacy_id: 6, name: "holiday_apartment", label_de: "Ferienwohnung", supports_reference: 1, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 80 },
    { id: 9, legacy_id: 7, name: "holiday_apartment_week", label_de: "Ferienwohnung pro Woche", supports_reference: 1, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 90 },
    { id: 10, legacy_id: 8, name: "tourist_dormitory_person", label_de: "Touristenlager (pro Person)", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 100 },
    { id: 11, legacy_id: 9, name: "sleeping_in_straw_person", label_de: "Schlafen im Stroh (pro Person)", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 110 },
    { id: 12, legacy_id: 13, name: "camping_pitch", label_de: "Zeltplatz/Camping", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 0, sort_order: 120 },
    { id: 13, legacy_id: 11, name: "custom_price_1", label_de: "Sonderpreis", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 1, sort_order: 130 },
    { id: 14, legacy_id: 12, name: "custom_price_2", label_de: "Sonderpreis", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 1, sort_order: 140 },
    { id: 15, legacy_id: 10, name: "custom_price_3", label_de: "Sonderpreis", supports_reference: 0, supports_price_max: 1, supports_from_flag: 1, is_custom_label: 1, sort_order: 150 },
    { id: 16, legacy_id: 16, name: "extra_breakfast", label_de: "Zus. Frühstück", supports_reference: 0, supports_price_max: 0, supports_from_flag: 0, is_custom_label: 0, sort_order: 160 },
    { id: 17, legacy_id: 17, name: "extra_breakfast_buffet", label_de: "Zus. Frühstücks Buffet", supports_reference: 0, supports_price_max: 0, supports_from_flag: 0, is_custom_label: 0, sort_order: 170 },
    { id: 18, legacy_id: 18, name: "extra_half_board_person", label_de: "Zus. Halbpension pro Person", supports_reference: 0, supports_price_max: 0, supports_from_flag: 0, is_custom_label: 0, sort_order: 180 },
    { id: 19, legacy_id: 19, name: "extra_full_board_person", label_de: "Zus. Vollpension pro Person", supports_reference: 0, supports_price_max: 0, supports_from_flag: 0, is_custom_label: 0, sort_order: 190 },
];

export const ROOM_PRICE_SPECIAL_DEFINITIONS = [
    { id: 1, legacy_id: 1, name: "per_room_and_night", label_de: "Preise pro Zimmer und Nacht", is_custom_label: 0, sort_order: 10 },
    { id: 2, legacy_id: 2, name: "season_or_room_dependent", label_de: "Preise je nach Saison / Zimmer", is_custom_label: 0, sort_order: 20 },
    { id: 3, legacy_id: 3, name: "vat_service_included", label_de: "Preise inkl. MwSt.,Service", is_custom_label: 0, sort_order: 30 },
    { id: 4, legacy_id: 4, name: "vat_service_included_city_tax_excluded", label_de: "Preise inkl. MwSt.,Service, exkl.CityTax", is_custom_label: 0, sort_order: 40 },
    { id: 5, legacy_id: 5, name: "group_prices_on_request", label_de: "Gruppenpreise auf Anfrage", is_custom_label: 0, sort_order: 50 },
    { id: 6, legacy_id: 6, name: "package_arrangements_on_request", label_de: "Pauschalarrangements auf Anfrage", is_custom_label: 0, sort_order: 60 },
    { id: 7, legacy_id: 7, name: "custom_special_1", label_de: "Zusatzhinweis", is_custom_label: 1, sort_order: 70 },
    { id: 8, legacy_id: 8, name: "custom_special_2", label_de: "Zusatzhinweis", is_custom_label: 1, sort_order: 80 },
];

const CURRENCIES = ["CHF", "Euro", "DKK", "GBP", "NOK", "SEK", "AUD", "CAD", "USD", "CNY", "JPY", "NZD", "HKD"];

const BREAKFAST_OPTIONS = [
    { value: 1, label: "keine Angaben" },
    { value: 2, label: "Preise inkl. Frühstück" },
    { value: 3, label: "Preise inkl. Frühstücksbuffet" },
    { value: 4, label: "Preise exkl. Frühstück" },
];

const EMPTY_ROOM_PRICE = {};

function sortedDefinitions(serverDefinitions, fallback) {
    const source = Array.isArray(serverDefinitions) && serverDefinitions.length ? serverDefinitions : fallback;
    return [...source].sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0));
}

const RoomPriceRow = React.memo(function RoomPriceRow({ definition, item, onRoomPriceChange }) {
    const customLabel = item?.custom_label || "";
    const reference = item?.reference || "";
    const priceMin = item?.price_min || "";
    const priceMax = item?.price_max || "";
    const isFrom = !!item?.is_from;

    return (
        <Box
            sx={{
                minWidth: 820,
                display: "grid",
                gridTemplateColumns: "minmax(230px, 1.5fr) 120px 130px 130px 90px",
                gap: 1,
                alignItems: "center",
                p: 1,
                borderTop: "1px solid",
                borderColor: "divider",
            }}
        >
            {definition.is_custom_label ? (
                <TextField
                    size="small"
                    label="Bezeichnung"
                    placeholder={definition.label_de || "Sonderpreis"}
                    value={customLabel}
                    onChange={(e) => onRoomPriceChange(definition, "custom_label", e.target.value)}
                />
            ) : (
                <Typography variant="body2">{definition.label_de || definition.name}</Typography>
            )}
            <TextField
                size="small"
                label="Personen"
                placeholder="z.B. 2"
                value={reference}
                onChange={(e) => onRoomPriceChange(definition, "reference", e.target.value)}
            />
            <TextField
                size="small"
                label="Preis von"
                placeholder="0,00"
                value={priceMin}
                onChange={(e) => onRoomPriceChange(definition, "price_min", e.target.value)}
            />
            <TextField
                size="small"
                label="bis Preis"
                placeholder="0,00"
                value={priceMax}
                onChange={(e) => onRoomPriceChange(definition, "price_max", e.target.value)}
            />
            <Checkbox
                size="small"
                checked={isFrom}
                onChange={(e) => onRoomPriceChange(definition, "is_from", e.target.checked)}
            />
        </Box>
    );
});

export default function SectionZimmer({ form, setForm }) {
    const quantityDefinitions = React.useMemo(
        () => sortedDefinitions(form.room_quantity_definitions, ROOM_QUANTITY_DEFINITIONS),
        [form.room_quantity_definitions]
    );
    const detailDefinitions = React.useMemo(
        () => sortedDefinitions(form.room_detail_definitions, ROOM_DETAIL_DEFINITIONS),
        [form.room_detail_definitions]
    );
    const priceDefinitions = React.useMemo(
        () => sortedDefinitions(form.room_price_definitions, ROOM_PRICE_DEFINITIONS),
        [form.room_price_definitions]
    );
    const specialDefinitions = React.useMemo(
        () => sortedDefinitions(form.room_price_special_definitions, ROOM_PRICE_SPECIAL_DEFINITIONS),
        [form.room_price_special_definitions]
    );

    const quantityById = React.useMemo(() => {
        const map = new Map();
        (form.room_quantities || []).forEach((item) => {
            map.set(Number(item.room_quantity_id || item.id), item.quantity ?? "");
        });
        return map;
    }, [form.room_quantities]);

    const detailById = React.useMemo(() => {
        const map = new Map();
        (form.room_details || []).forEach((item) => {
            map.set(Number(item.room_detail_id || item.id), item);
        });
        return map;
    }, [form.room_details]);

    const priceById = React.useMemo(() => {
        const map = new Map();
        (form.room_prices || []).forEach((item) => {
            map.set(Number(item.room_price_id || item.id), item);
        });
        return map;
    }, [form.room_prices]);

    const specialById = React.useMemo(() => {
        const map = new Map();
        (form.room_price_specials || []).forEach((item) => {
            map.set(Number(item.special_id || item.id), item);
        });
        return map;
    }, [form.room_price_specials]);

    const setQuantity = (definitionId, value) => {
        setForm((f) => {
            const id = Number(definitionId);
            const next = (f.room_quantities || [])
                .filter((item) => Number(item.room_quantity_id || item.id) !== id);

            if (String(value).trim() !== "") {
                next.push({ room_quantity_id: id, quantity: value });
            }

            return { ...f, room_quantities: next };
        });
    };

    const toggleDetail = (definition, checked) => {
        const id = Number(definition.id);
        setForm((f) => {
            const next = (f.room_details || [])
                .filter((item) => Number(item.room_detail_id || item.id) !== id);
            if (checked) {
                next.push({ room_detail_id: id, custom_label: definition.label_de || definition.name });
            }
            return { ...f, room_details: next };
        });
    };

    const setDetailLabel = (definition, value) => {
        const id = Number(definition.id);
        setForm((f) => {
            const existing = (f.room_details || [])
                .filter((item) => Number(item.room_detail_id || item.id) !== id);
            return {
                ...f,
                room_details: [
                    ...existing,
                    { room_detail_id: id, custom_label: value || definition.label_de || definition.name },
                ],
            };
        });
    };

    const setRoomPriceSetting = React.useCallback((key, value) => {
        setForm((f) => ({
            ...f,
            room_price_settings: {
                ...(f.room_price_settings || {}),
                [key]: value,
            },
        }));
    }, [setForm]);

    const setRoomPrice = React.useCallback((definition, key, value) => {
        const id = Number(definition.id);
        setForm((f) => {
            const existing = (f.room_prices || []).find((item) => Number(item.room_price_id || item.id) === id) || {};
            const nextItem = { ...existing, room_price_id: id, [key]: value };
            const hasValue = ["custom_label", "reference", "price_min", "price_max"].some((field) => String(nextItem[field] || "").trim()) || !!nextItem.is_from;
            const previous = f.room_prices || [];
            const index = previous.findIndex((item) => Number(item.room_price_id || item.id) === id);
            const next = index === -1 ? [...previous] : [...previous.slice(0, index), ...previous.slice(index + 1)];
            if (hasValue) {
                next.splice(index === -1 ? next.length : index, 0, nextItem);
            }
            return {
                ...f,
                room_prices: next,
            };
        });
    }, [setForm]);

    const toggleSpecial = (definition, checked) => {
        const id = Number(definition.id);
        setForm((f) => {
            const next = (f.room_price_specials || []).filter((item) => Number(item.special_id || item.id) !== id);
            if (checked) {
                next.push({ special_id: id, custom_label: definition.is_custom_label ? "" : definition.label_de || definition.name });
            }
            return { ...f, room_price_specials: next };
        });
    };

    const setSpecialLabel = (definition, value) => {
        const id = Number(definition.id);
        setForm((f) => {
            const existing = (f.room_price_specials || []).filter((item) => Number(item.special_id || item.id) !== id);
            return {
                ...f,
                room_price_specials: [
                    ...existing,
                    { special_id: id, custom_label: value || definition.label_de || definition.name },
                ],
            };
        });
    };

    return (
        <Box sx={{ display: "grid", gap: 3 }}>
            <Box>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Anzahl
                </Typography>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))", lg: "repeat(3, minmax(0, 1fr))" },
                        gap: 1.5,
                    }}
                >
                    {quantityDefinitions.map((definition) => (
                        <TextField
                            key={definition.id}
                            size="small"
                            type="number"
                            label={definition.label_de || definition.name}
                            value={quantityById.get(Number(definition.id)) ?? ""}
                            inputProps={{ min: 0, step: 1 }}
                            onChange={(e) => setQuantity(definition.id, e.target.value)}
                        />
                    ))}
                </Box>
            </Box>

            <Box>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Zimmerpreise
                </Typography>
                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" }, gap: 1.5, mb: 2 }}>
                    <TextField
                        size="small"
                        label="Kundenlink detaillierte Zimmerpreise"
                        placeholder="http://"
                        value={form.room_price_settings?.room_prices_url || ""}
                        onChange={(e) => setRoomPriceSetting("room_prices_url", e.target.value)}
                    />
                    <FormControl size="small">
                        <InputLabel id="room-currency-label">Preisangaben in</InputLabel>
                        <Select
                            labelId="room-currency-label"
                            label="Preisangaben in"
                            value={form.room_price_settings?.currency || "CHF"}
                            onChange={(e) => setRoomPriceSetting("currency", e.target.value)}
                        >
                            {CURRENCIES.map((currency) => (
                                <MenuItem key={currency} value={currency}>{currency}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                <Box sx={{ overflowX: "auto", border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
                    <Box
                        sx={{
                            minWidth: 820,
                            display: "grid",
                            gridTemplateColumns: "minmax(230px, 1.5fr) 120px 130px 130px 90px",
                            gap: 1,
                            alignItems: "center",
                            p: 1,
                            bgcolor: "action.hover",
                        }}
                    >
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>Unterkunft</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>Personen</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>Preis von</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>bis Preis</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>Preis ab</Typography>
                    </Box>
                    {priceDefinitions.map((definition) => {
                        const item = priceById.get(Number(definition.id)) || EMPTY_ROOM_PRICE;
                        return (
                            <RoomPriceRow
                                key={definition.id}
                                definition={definition}
                                item={item}
                                onRoomPriceChange={setRoomPrice}
                            />
                        );
                    })}
                </Box>

                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 3, mt: 2 }}>
                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            Frühstück
                        </Typography>
                        <RadioGroup
                            value={form.room_price_settings?.breakfast_option ?? ""}
                            onChange={(e) => setRoomPriceSetting("breakfast_option", e.target.value)}
                        >
                            {BREAKFAST_OPTIONS.map((option) => (
                                <FormControlLabel
                                    key={option.value}
                                    value={String(option.value)}
                                    control={<Radio size="small" />}
                                    label={option.label}
                                />
                            ))}
                        </RadioGroup>
                    </Box>

                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            Besonderes
                        </Typography>
                        <Box sx={{ display: "grid", gap: 1 }}>
                            {specialDefinitions.map((definition) => {
                                const selected = specialById.has(Number(definition.id));
                                const item = specialById.get(Number(definition.id));
                                return (
                                    <Box key={definition.id} sx={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: 1, alignItems: "center" }}>
                                        <Checkbox
                                            size="small"
                                            checked={selected}
                                            onChange={(e) => toggleSpecial(definition, e.target.checked)}
                                        />
                                        {definition.is_custom_label ? (
                                            <TextField
                                                size="small"
                                                disabled={!selected}
                                                value={selected ? (item?.custom_label || "") : ""}
                                                onChange={(e) => setSpecialLabel(definition, e.target.value)}
                                            />
                                        ) : (
                                            <Typography variant="body2">{definition.label_de || definition.name}</Typography>
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                </Box>

                <TextField
                    sx={{ mt: 2 }}
                    fullWidth
                    multiline
                    minRows={3}
                    label="Zimmer-Info"
                    value={form.room_price_settings?.room_info || ""}
                    onChange={(e) => setRoomPriceSetting("room_info", e.target.value)}
                />
            </Box>

            <Box>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Zimmer mit
                </Typography>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
                        gap: 1,
                    }}
                >
                    {detailDefinitions.map((definition) => {
                        const selected = detailById.has(Number(definition.id));
                        const item = detailById.get(Number(definition.id));
                        return (
                            <Box key={definition.id} sx={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: 1, alignItems: "center" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={selected}
                                            onChange={(e) => toggleDetail(definition, e.target.checked)}
                                        />
                                    }
                                    label=""
                                    sx={{ m: 0 }}
                                />
                                <TextField
                                    size="small"
                                    disabled={!selected}
                                    value={selected ? (item?.custom_label || definition.label_de || "") : (definition.label_de || "")}
                                    onChange={(e) => setDetailLabel(definition, e.target.value)}
                                />
                            </Box>
                        );
                    })}
                </Box>
            </Box>
        </Box>
    );
}
